import { Component, OnInit, AfterViewInit, Input } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { BaseTemplate } from "../../../../../../shared/baseTemplate";
import { AuthService } from "../../../../../../shared/services/auth.service";
import { CurrencyExchangeService } from "../../../../../../shared/services/currency-exchange.service";
import { GetBusinessProfileService } from "../../../../../../shared/services/get-business-profile.service";
import { Invoice } from "../../../../buyer";
import { GetCalculatesParamsService } from "../../../../services/get-calculates-params.service";
import { ViewProductInfoHandlerService } from "../../../../services/view-product-info-handler.service";
import { ProductCreationHelperService } from "src/app/dashboard/seller/payment-pages/services/product-creation-helper.service";
import { ProductTypes } from "src/app/shared/product/productTypes";

@Component({
  selector: 'app-claim',
  templateUrl: './claim.component.html',
  styleUrls: ['./claim.component.scss']
})
export class ClaimComponent extends BaseTemplate
implements OnInit, AfterViewInit {
  expiryDate: any;
  description: any;
  ClaimItems: Invoice[] = [];
  ifTaxesPercentage: boolean = false;
  claimNumber: number = 0;
  dueDate: any;
  issuanceDate!: Date;
  businessLogo: string = "";
  @Input() productObject: any;
  businessObject: any;

  constructor(
    vpihs: ViewProductInfoHandlerService,
    getBusinessProfileService: GetBusinessProfileService,
    auth: AuthService,
    public exchangeService: CurrencyExchangeService,
    public getCalculatesParamsService: GetCalculatesParamsService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private productCreationHelperService: ProductCreationHelperService
  ) {
    super(vpihs, getBusinessProfileService, auth, exchangeService, getCalculatesParamsService);
  }

  async ngOnInit() {
    this.businessObject = this.productObject.Business;
    await this.initCurrencies();

    this.issuanceDate = this.productObject.createdAt;

    if (this.businessObject.logo) {
      this.businessLogo = this.businessObject.logo;
    }
    this.expiryDate = this.productObject.expiryDate;
    this.description = this.getNewProductValueByFieldName("description", "ProductExtraInfos");
    const items = this.productObject.ClaimItems || [];
    // set default quantity
    this.vpihs.quantity = 1;
    this.quantity = 1;

    for (const item of items) {
      this.ClaimItems.push({
        Item_Name: item.name,
        Price: item.price,
        Quantity: item.quantity
      });
    }
    this.claimNumber = this.productObject['Claim'].claimNumber;
    this.dueDate = this.productObject['Claim'].dueDate;
    const taxesObj = this.productObject.ProductTax;
    if (taxesObj) {
      this.taxes = taxesObj.taxes || 0;
      const taxesType = taxesObj.type;
      if (taxesType) {
        if (taxesObj.type === "Percentage") {
          this.ifTaxesPercentage = true;
        }
      }
    }
    this.commitChanges();

    this.productCreationHelperService.checkParamsForOpriningCopyDialog(window.location.search, {
      serilizedUrl: window.location.href?.split("?")[0],
      product: {
        name: this.productObject.productName,
        type: ProductTypes.Collection
      }
    })
  }

  proceedToPayment() {
    this.commitChanges();
    this.router.navigate(["buyerinfo"], {
      relativeTo: this.activatedRoute,
      state: { CollectionsCustomerId: this.productObject.Claim.CollectionsCustomerId},
    });
  }
}
